const PropTypes = require('prop-types');
const React = require('react');
const CreditCardBox = require('./credit_card_box');
const AdyenCreditCardForm = require('./adyen_credit_card_form');
const classNames = require('classnames');
const { AppConfigStore } = require('@reverbdotcom/discovery-ui');

const ADYEN = 'adyen';

class EditableCreditCard extends React.Component {
  get isPrimary() {
    return this.props.creditCard.creditCardId === this.props.primaryCardId;
  }

  radioInputId() {
    return `credit-card-select-${this.props.creditCard.creditCardId}`;
  }

  handleFormUpdate() {
    if (this.isPersistedCard()) {
      this.cancelEditing();
    }
    this.props.handleUpdate();
  }

  radioInput() {
    if (!this.props.selectable) { return null; }

    return (
      <input
        id={this.radioInputId()}
        type="radio"
        value={this.props.creditCard.creditCardId}
        className="boxed-list__toggle"
        defaultChecked={this.props.selected}
      />
    );
  }

  nowEditing() {
    this.props.handleEditing(this.props.creditCard.creditCardId);
  }

  cancelEditing() {
    this.props.handleEditing(null);
  }

  isPersistedCard() {
    return this.props.creditCard.creditCardId != null;
  }

  creditCardForm() {
    return (
      <AdyenCreditCardForm
        creditCard={this.props.creditCard}
        formErrors={this.props.formErrors}
        cancelEditing={() => this.cancelEditing()}
        handleUpdate={() => this.handleFormUpdate()}
        displayCancelEditLink={this.props.displayCancelEditLink}
        countriesForSelect={this.props.countriesForSelect}
        formObjectName={this.props.formObjectName}
      />
    );
  }

  componentToRender() {
    if (this.props.editing) {
      return this.creditCardForm();
    }

    return (
      <CreditCardBox
        creditCard={this.props.creditCard}
        nowEditing={() => this.nowEditing()}
        isPrimary={this.isPrimary}
        handleUpdate={() => this.handleFormUpdate()}
        updatePrimaryCard={cardId => this.props.updatePrimaryCard(cardId)}
      />
    );
  }

  wrappedCreditCard() {
    if (this.props.selectable) {
      return (
        <label
          htmlFor={this.radioInputId()}
          className="boxed-list__item boxed-list__item--selectable"
          onClick={() => this.props.closeNewCreditCardForm()}
        >
          {this.componentToRender()}
        </label>
      );
    }

    const classes = classNames(
      'boxed-list__item',
      { 'boxed-list__item--active': this.props.editing },
    );

    return (
      <div className={classes}>
        {this.componentToRender()}
      </div>
    );
  }

  render() {
    return (
      <li>
        {this.radioInput()}
        {this.wrappedCreditCard()}
      </li>
    );
  }
}

EditableCreditCard.propTypes = {
  creditCard: PropTypes.shape({
    creditCardId: PropTypes.string,
    cardType: PropTypes.string,
    lastFour: PropTypes.string,
    cardholderName: PropTypes.string,
    expirationMonth: PropTypes.string,
    expirationYear: PropTypes.string,
    fullExpirationYear: PropTypes.string,
    streetAddress: PropTypes.string,
    extendedAddress: PropTypes.string,
    locality: PropTypes.string,
    region: PropTypes.string,
    postalCode: PropTypes.string,
    countryCode: PropTypes.string,
    cardSource: PropTypes.string,
  }).isRequired,
  countriesForSelect: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleUpdate: PropTypes.func.isRequired,
  selectable: PropTypes.bool.isRequired,
  primaryCardId: PropTypes.string,
  selected: PropTypes.bool,
  editing: PropTypes.bool,
  displayCancelEditLink: PropTypes.bool,
  formObjectName: PropTypes.string,
  closeNewCreditCardForm: PropTypes.func,
  updatePrimaryCard: PropTypes.func,
  handleEditing: PropTypes.func.isRequired,
  formErrors: PropTypes.string,
};

module.exports = EditableCreditCard;



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/editable_credit_card.jsx